import { Directive, TemplateRef } from '@angular/core'

@Directive({ selector: 'ng-template[signerForm]' })
export class SignerFormDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
